import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

var HorizontalScroll = function HorizontalScroll(_ref) {
  var css = _ref.css,
      className = _ref.className,
      children = _ref.children,
      scroll = _ref.scroll,
      classNameForHsWrapper = _ref.classNameForHsWrapper,
      scrollRef = _ref.scrollRef;
  var hsClassName = classNames(styles.hsContainer, className);
  var stylesScrollbar = scroll ? {
    padding: '1.25rem 0 0'
  } : {};

  var validateScrollbar = function validateScrollbar(scroll) {
    return !scroll && styles.noScrollbar;
  };

  var hsChildClassName = classNames(styles.hs, styles.full, validateScrollbar(scroll));
  var hsWrapperClassName = classNames(styles.hsWrapper, classNameForHsWrapper);
  return /*#__PURE__*/React.createElement("div", {
    className: hsClassName,
    style: css
  }, /*#__PURE__*/React.createElement("div", {
    className: hsWrapperClassName,
    style: stylesScrollbar
  }, /*#__PURE__*/React.createElement("div", {
    className: hsChildClassName,
    ref: scrollRef,
    "data-testid": "hsContainer"
  }, children)));
};

export default HorizontalScroll;